const getBackgroundImageSourcesSet = (blockNode) => {
  const backgroundContainer = blockNode.querySelector('ws-background-container');
  return backgroundContainer && backgroundContainer.srcset;
};

export default getBackgroundImageSourcesSet;
